import './index.scss';
import React, { useEffect, useState } from 'react';
import Utils from '../../CourseApp/Helper/utils';

function DurationControl({ structure, saveValue, defaultValue, controlKey, selectedSlide}) {
    const defaultDurationInSeconds = selectedSlide.template.getDuration();
    const defaultDurationInMinute = Math.round(defaultDurationInSeconds/60);

    const [controlValue, setControlValue] = useState(defaultValue ?? defaultDurationInMinute);
    const controlLabel = structure.labelOnChangeOption;
    // const controlIsUsed = selectedSlide.data.platform === 'bunnynet';
    const controlIsUsed = structure.relatedRequired.length > 0 && structure.relatedRequired.includes(selectedSlide.data.platform);

    const handleChange = (e) => {
        let currentValue = e.currentTarget.value;
        let isValid = true;

        if (currentValue.length > 0 && !Utils.validateIsNumeric(currentValue)) {
            isValid = false;
        }
        if (currentValue.length > 0 && !(parseInt(currentValue) >= 1 && parseInt(currentValue) <= 300)) {
            isValid = false;
        }

        if (!isValid) {
            e.currentTarget.className = 'form-control is-invalid text-danger';
        } else {
            e.currentTarget.className = 'form-control';
        }

        setControlValue(currentValue);
        saveValue(currentValue);
    }

    useEffect(() => {
        if (typeof defaultValue !== 'undefined') {
            setControlValue(defaultValue);
        } else {
            setControlValue('');
        }
    }, [defaultValue]);

    return (
        <>
            {controlIsUsed && (
                <>
                <div className="tbcourse-editor-control-item-label">
                    {controlLabel}
                </div>
                <div className="tbcourse-editor-control-duration">
                    <div className='input-group'>
                        <input type="text" className="form-control" placeholder={structure.placeholder} value={controlValue} onChange={handleChange}></input>
                        <span className='input-group-text'>Minutes</span>
                    </div>
                    <small className='form-text'>{structure.helpText}</small>
                </div>
                </>
            )}
        </>
    );
}

export default DurationControl;
